export default "<template>\n\n  <KIcon icon=\"helpOutline\" />\n\n</template>\n";